module.exports = __webpack_public_path__ + "img/step-6.0417cb46.jpg";